<template>
  <div id="app" class="app">
    <user v-if="showControls"></user>
    <button class="logout" type="button" @click="logoutClicked" v-if="$route.name!=='Login'" title="Log out">
      <fa-icon icon="power-off"></fa-icon>
    </button>
    <Navigation v-if="showControls"></Navigation>
    <router-view/>
    <div class="bar" v-if="updateExists">
      Er is een nieuwe versie beschikbaar
      <button class="bar__button" @click="refreshApp">Update</button>
    </div>
    <div class="bar" v-if="deferredPrompt">
      <p>Download deze app om deze makkelijker te kunnen raadplegen.</p>
      <button class="bar__button" @click="declineInstall">Dismiss</button>
      <button class="bar__button" @click="acceptInstall">Accept</button>
    </div>
    <div class="offline" v-if="offline"><div><p><fa-icon icon="exclamation-triangle"></fa-icon></p><p>Geen internet verbinding, zorg voor een connectie met het internet om de app te kunnen gebruiken.</p></div></div>
  </div>
</template>

<style lang="scss">
@import 'assets/sass/app';
</style>

<script>
import update from './mixins/update';
import {mapActions} from "vuex";
import Navigation from "./components/Navigation";
import User from "./components/User";
//import LanguageSelector from "./components/LanguageSelector";
export default {
  name: 'App',

  mixins:[update],

  data() {
    return {
      registration: null,
      offline: false,
      deferredPrompt: null
    }
  },

  created(){
    window.addEventListener('beforeinstallprompt', evt => {
      evt.preventDefault();
      this.deferredPrompt = evt;
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
  },

  mounted() {
    document.addEventListener('swUpdated',this.showUpdateUI);
    window.addEventListener('offline',this.offlineHandler);
    window.addEventListener('online',this.onlineHandler);
  },
  beforeDestroy() {
    document.removeEventListener('swUpdated',this.showUpdateUI);
    window.removeEventListener('offline',this.offlineHandler);
    window.removeEventListener('online',this.onlineHandler);
  },

  components: {Navigation, /*LanguageSelector,*/ User},

  computed: {
    showControls() {
      return this.$route.name !== 'Login' && this.$route.name !== 'ResetPassword';
    }
  },

  methods: {
    ...mapActions('auth', [
      'logout'
    ]),

    logoutClicked() {
      console.log('-- logging out --');
      this.logout();
    },

    onlineHandler(){
      this.offline = false;
    },
    offlineHandler(){
      this.offline = true;
    },

    async declineInstall(){
      this.deferredPrompt = null;
    },

    async acceptInstall(){
      this.deferredPrompt.prompt();
    }
  }
}
</script>
